<template>
    <div v-if="addresses">
        <!-- Create new gifting address -->
        <div class="container mx-auto text-center max-w-xs pt-4">
            <div class="deliveryAddressCard__container">
                <div v-if="!showAddressForm"
                     class="accountDeliveryAddresses__createCtaCtaContainer border-b border-black">
                    <div class="accountDeliveryAddresses__createCtaIcon"></div>
                    <p class="ml-1 m-0 mt-1">
                        <a href="#" @click.prevent="toggleCreateForm"
                            v-text="$t('GIFTING_ADDRESS_TABLE_ADD_NEW')"></a>
                    </p>
                </div>
                <div :class="createGiftingAddressAccordionClass">
                    <create-gifting-address-form
                        @address-selected="handleAddressSelected"
                        @closed="toggleCreateForm"/>
                </div>
            </div>
            <div v-if="addresses.length">
                <p class="py-5" v-text="$t('GIFTING_ADDRESS_TABLE_OR_CHOOSE')"></p>
            </div>
        </div>

        <div v-if="addresses.length" class="background--paper divider--container py-10">
            <div class="divider-white--top"></div>
            <div class="container mx-auto text-center max-w-3xl">
                <div class="flex flex-wrap">
                    <gifting-address-item
                        :key="index"
                        :address="address"
                        v-for="(address, index) in addresses"
                        @address-selected="handleAddressSelected">
                    </gifting-address-item>
                </div>
                <div class="divider-white--bottom"></div>
            </div>
        </div>
    </div>
</template>

<script>
import GiftingAddressItem from '@/components/partials/account/gifting/deliveryAddress/GiftingAddressItem';
import CreateGiftingAddressForm from '@/components/partials/account/gifting/deliveryAddress/CreateGiftingAddressForm';
import { GIFT_TYPE_ONE_OFF, SECTION_DELIVERY_ADDRESS } from '@/constants/Gifting';

export default {
    name: 'GiftingAddressesTable',
    data() {
        return {
            showCreateAddressForm: false,
        };
    },
    computed: {
        addresses() {
            return this.$store.getters['address/getGiftingAddresses'];
        },
        createGiftingAddressAccordionClass() {
            return this.showAddressForm ? 'accordion__lg accordion__lg--active' : 'accordion__lg';
        },
        showAddressForm() {
            return this.addresses === null || this.addresses.length ? this.showCreateAddressForm : this.addresses.length === 0;
        },
        giftType() {
            return this.$store.getters['gifting/getGiftType'];
        },
        vaseEnabled() {
            return this.$store.getters['account/getGiftingVaseEnabled'];
        },
        shopEnabled() {
            return this.$store.getters['account/getShopInGiftingEnabled'];
        },
    },
    components: {
        CreateGiftingAddressForm,
        GiftingAddressItem,
    },
    methods: {
        toggleCreateForm() {
            this.showCreateAddressForm = !this.showCreateAddressForm;
        },
        async handleAddressSelected() {
            await this.$store.dispatch('address/fetchAllGiftingAddresses', true);
            if (this.fromHolidayBoxModal) {
                this.showCreateAddressForm = false;
                this.$emit('addressSelected');
                return;
            }

            this.$store.commit('gifting/setSectionComplete', SECTION_DELIVERY_ADDRESS);
            if (this.giftType === GIFT_TYPE_ONE_OFF && this.vaseEnabled) {
                this.$router.push({ name: 'account.gifting.freddies-addons' });
            } else if (this.shopEnabled) {
                this.$router.push({ name: 'account.gifting.freddies-shop' });
            } else {
                this.$router.push({ name: 'account.gifting.delivery-day' });
            }
        },
    },
    mounted() {
        this.$store.dispatch('address/fetchAllGiftingAddresses');
    },
};
</script>
